import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-web-pages',
  templateUrl: './web-pages.component.html',
  styleUrls: ['./web-pages.component.css']
})
export class WebPagesComponent implements OnInit {
  SelectedWebType: string = 'termsAndConditions';
  web_pages: any;
  web: any;
  urlArray: any = [];
  constructor(private services: SharedService, private router: Router) { }

  ngOnInit(): void {
    const url = this.router.url;
    this.urlArray = url.split("/")
    this.getWebpages()
  }
  getWebpages() {
    this.services.webPagesGet(this.urlArray[2]).subscribe((response: any) => {
      if (response.body?.data?.webpage_string) {
        this.web_pages = response.body.data.webpage_string
        let myContainer = <HTMLElement>document.getElementById('web_page');
        myContainer.innerHTML = this.web_pages;
        // this.web = this.web_pages.replace(/<[^>]+>/g, '')

      }
    })
  }
}
